import './RadioFilterButton.scss';
import { useEffect, useRef } from 'react';
export type RadioFilterButtonProps = {
	onFundTypeFilterChange: (value: string) => void;
	handleAnswered: (value: string) => Promise<void>;
	labels: string[];
	selectedFilter: string;
};

const RadioFilterButton: React.FC<RadioFilterButtonProps> = ({
	onFundTypeFilterChange,
	handleAnswered,
	labels,
	selectedFilter,
}) => {
	const buttonRefs = useRef<HTMLButtonElement[]>([]);

	useEffect(() => {
		buttonRefs.current.forEach((button) => {
			if (button.value === selectedFilter) {
				button.focus();
			}
		});
	}, []);

	const handleAjax = (event: React.MouseEvent<HTMLButtonElement>) => {
		const value: string = event.currentTarget.value;
		onFundTypeFilterChange(value);
		handleAnswered(value);
	};

	return (
		<>
			<h2 className="buttonContainerTitle" id="buttonContainerTitle">
				FUND TYPE
			</h2>
			<div
				aria-describedby="filter-change-context"
				aria-labelledby="buttonContainerTitle"
				className="buttonContainer content row"
				id="buttonContainer"
				role="group"
			>
				{labels.map((label, index) => {
					const labelCased = label.replaceAll(' ', '');
					return (
						<button
							type="button"
							role="radio"
							key={labelCased}
							value={label}
							onClick={handleAjax}
							name="fundTypeFilterRadio"
							aria-checked={label === selectedFilter}
							className={
								'col-lg-3 col-md-3 col-sm-3 col-6 selector fundTypeBtn ' +
								(label === selectedFilter ? 'selectedFundTypeBtn' : '')
							}
							// eslint-disable-next-line @typescript-eslint/ban-ts-comment
							// @ts-ignore
							ref={(btn) => (buttonRefs.current[index] = btn)}
						>
							<span className="fundTypeText">{label}</span>
						</button>
					);
				})}
			</div>
			<span id="filter-change-context" style={{ display: 'none' }}>
				Changing filter will update the content on the page.
			</span>
		</>
	);
};

export default RadioFilterButton;
